import { render, staticRenderFns } from "./tournamentCard.vue?vue&type=template&id=09d90acb&scoped=true&"
import script from "./tournamentCard.vue?vue&type=script&lang=js&"
export * from "./tournamentCard.vue?vue&type=script&lang=js&"
import style0 from "./tournamentCard.vue?vue&type=style&index=0&id=09d90acb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d90acb",
  null
  
)

export default component.exports